module.exports = __webpack_public_path__ + "img/951.72f1c312.jpg";